// import { nextTick } from 'vue';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export default {
  install: (app, options) => {
    const defaultSettings = {
      debug: false,
      headerHeight: 0,
      menuSelector: '.page-menu'
    };

    const settings = Object.assign(defaultSettings, options);

    const initSections = () => {
      const sections = document.querySelectorAll('[data-section]');
      const pageMenu = document.querySelector(settings.menuSelector);

      if (pageMenu) {
        sections.forEach((section, index) => {
          ScrollTrigger.create({
            trigger: `[data-section="${section.dataset.section}"]`,
            markers: settings.debug,
            start: `0% 30%`,
            end: `100% 30%`,
            onEnter: (self) => {
              activateLink(`${settings.menuSelector} li:nth-child(${index + 1}) button`);
            },
            onEnterBack: (self) => {
              activateLink(`${settings.menuSelector} li:nth-child(${index + 1}) button`);
            },
            onLeave: (self) => {
              deactivateLink(`${settings.menuSelector} li:nth-child(${index + 1}) button`);
            },
            onLeaveBack: (self) => {
              deactivateLink(`${settings.menuSelector} li:nth-child(${index + 1}) button`);
            },
          });
        });
      }
    };

    const activateLink = (el) => {
      document.querySelector(el).classList.add('active');
    }

    const deactivateLink = (el) => {
      document.querySelector(el).classList.remove('active');
    }

    const scrollToSection = (section, callback) => {
      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: `[data-section="${section}"]`,
          offsetY: settings.headerHeight
        },
        // onComplete: () => {
        //   removeParam("goto")
        // }
      });
    };

    const getParam = (param) => {
      var result = null,
        tmp = [];

      location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === param) result = decodeURIComponent(tmp[1]);
        });

      if (result === 'undefined') {
        return null
      } else {
        return result
      }
    }

    const removeParam = (key) => {
      const sourceURL = location.protocol + '//' + location.host + location.pathname
      var urlparts = window.location.search.split('?')

      if (urlparts.length >= 2) {
        var prefix = encodeURIComponent(key) + '='
        var pars = urlparts[1].split(/[&;]/g)

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
          //idiom for string.startsWith
          if (pars[i].lastIndexOf(prefix, 0) !== -1) {
            pars.splice(i, 1)
          }
        }

        window.history.replaceState(null, null, sourceURL + urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : ''))
      }
    }

    const paramSection = getParam('section');

    if (paramSection) {
      scrollToSection(paramSection);
      removeParam('section');
    }

    setTimeout(() => {
      initSections();
    }, 0);

    app.config.globalProperties.$scrollTo = scrollToSection;
    app.provide('$scrollTo', scrollToSection);
  }
}